// import auth from '@/utils/auth'
// import setCache from '@/utils/setCache'
// import request from '@/utils/request'
import store from '@/vuex/store.js'
import auth from '@/utils/auth.js'

// const Login = resolve => require(['../pages/login/login.vue'], resolve)
const Layout = resolve =>
  require(['../components/layout/baseLayout.vue'], resolve)
const OrderList = resolve => require(['../pages/order/list.vue'], resolve)
const listForLxq = resolve =>
  require(['../pages/order/listForLxq.vue'], resolve)
// const PriceSetup = resolve => require(['../pages/pricesetup/priceSetup.vue'], resolve)
const FeedbackList = resolve => require(['../pages/feedback/list.vue'], resolve)
const ShipOrderList = resolve => require(['../pages/shipOrder/list.vue'], resolve)
const ApkList = resolve => require(['../pages/apk/list.vue'], resolve)
const PcApk = resolve => require(['../pages/apk/pcApk.vue'], resolve)
// const UserList = resolve => require(['../pages/user/list.vue'], resolve)
const Administration = resolve =>
  require(['../pages/user/administration.vue'], resolve)
const BannerList = resolve => require(['../pages/banner/list.vue'], resolve)
// const ReportList = resolve => require(['../pages/report/list.vue'], resolve)
const login = resolve => require(['../Login.vue'], resolve)
const ActivationcodeList = resolve =>
  require(['../pages/activationcode/list.vue'], resolve)
const PrivateView = resolve =>
  require(['../pages/privateView/index.vue'], resolve)
const regulatory = resolve =>
  require(['../pages/regulatory/regulatory.vue'], resolve)
const reportData = resolve =>
  require(['../pages/reportData/reportData.vue'], resolve)
const historyData = resolve =>
  require(['../pages/reportData/historyData.vue'], resolve)
const configerData = resolve =>
  require(['../pages/reportData/configerData.vue'], resolve)

export default {
  mode: 'history',
  saveScrollPosition: true,
  base: __dirname,
  routes: getRoutes()
}
function getRoutes() {
  let routes = [
    {
      // rule: [],
      path: '/login',
      component: login
    },
    {
      // rule: [],
      path: '/',
      redirect: '/order/list'
    },
    // {
    //   // rule: [3],
    //   authId: 'view_menu_not_auth',
    //   path: '/overseas',
    //   component: Layout,
    //   children: [
    //     {
    //       title: '订单列表',
    //       path: 'list',
    //       component: () => import('../pages/order/overseasList.vue'),
    //       name: 'overseasList',
    //     }
    //   ]
    // },
    // /overseas/list
    {
      // rule: [0, 1, 4],
      authId: 'view_menu_order',
      path: '/order',
      component: Layout,
      // beforeEnter: requireAuth,
      children: [
        {
          path: 'list',
          component: OrderList,
          title: '订单列表',
          name: 'orderList',
          meta: { index: '7', keepAlive: true }
        }
      ]
    },

    // {
    //   path: '/price',
    //   component: Layout,
    //   // beforeEnter: requireAuth,
    //   children: [{
    //     path: 'setup',
    //     component: PriceSetup,
    //     title: '价格配置',
    //     name: 'priceList',
    //     meta: { index: '7', keepAlive: true },
    //   },
    //   ]
    // },
    {
      authId: 'view_menu_feedback',
      // rule: [0],
      path: '/feedback',
      component: Layout,
      // beforeEnter: requireAuth,
      children: [
        {
          path: 'list',
          component: FeedbackList,
          name: 'feedbackList',
          title: '反馈列表',
          meta: { index: '7', keepAlive: true }
        }
      ]
    },
    {
      authId: 'view_menu_ship_order',
      path: '/shipOrder',
      component: Layout,
      children: [
        {
          path: 'list',
          component: ShipOrderList,
          name: 'shipOrderList',
          title: '邮寄订单列表',
          meta: { index: '6', keepAlive: true }
        }
      ]
    },
    // {
    //   authId: 'view_menu_banner',
    //   // rule: [0],
    //   path: '/banner',
    //   component: Layout,
    //   children: [
    //     {
    //       path: 'list',
    //       component: BannerList,
    //       name: 'bannerList',
    //       title: 'banner管理',
    //       meta: { index: '9', keepAlive: true }
    //     }
    //   ]
    // },
    //   {
    //     path: '/report',
    //     component: Layout,
    //     children: [{
    //       path: 'list',
    //       component: ReportList,
    //       name: 'reportList',
    //       title: '日报',
    //       meta: { index: '10', keepAlive: true },
    //     },
    //   ]
    // },
    // {
    //   authId: 'view_menu_apk_tg',
    //   // rule: [0],
    //   path: '/apk',
    //   component: Layout,
    //   // beforeEnter: requireAuth,
    //   children: [{
    //     path: 'list',
    //     component: ApkList,
    //     name: 'apkList',
    //     title: '推广包上传',
    //     meta: {index: '7', keepAlive: true},
    //   },
    //   ]
    // },
    // {
    //   authId: 'view_menu_apk_pc',
    //   // rule: [0],
    //   path: '/apk',
    //   component: Layout,
    //   // beforeEnter: requireAuth,
    //   children: [{
    //     path: 'pcApk',
    //     component: PcApk,
    //     name: 'pcApk',
    //     title: '上传PC',
    //     meta: {index: '11', keepAlive: true},
    //   },
    //   ]
    // },
    // {
    //   path: '/user',
    //   component: Layout,
    //   // beforeEnter: requireAuth,
    //   children: [{
    //     path: 'list',
    //     component: UserList,
    //     title: '用户列表',
    //     name: 'orderList',
    //     meta: { index: '8', keepAlive: true },
    //   },
    //   ]
    // },
    {
      authId: 'view_menu_staff',
      // rule: [0],
      path: '/user',
      component: Layout,
      // beforeEnter: requireAuth,
      children: [
        {
          path: 'administration',
          component: Administration,
          title: '权限管理',
          name: 'administration',
          meta: { index: '8', keepAlive: true }
        }
      ]
    },
    // {
    //   authId: 'view_menu_pc_list',
    //   // rule: [0, 3, 4],
    //   path: '/order',
    //   component: Layout,
    //   children: [{
    //     path: 'PClist',
    //     component: () => import('../pages/order/PClist'),
    //     title: '电脑恢复用户管理',
    //     name: 'PClist',
    //     meta: {index: '11', keepAlive: true},
    //   },
    //   ]
    // },
    // {
    //   authId: 'view_menu_app_list',
    //   // rule: [0, 3, 4],
    //   path: '/order',
    //   component: Layout,
    //   children: [
    //     {
    //       path: 'Applist',
    //       component: () => import('../pages/order/Applist'),
    //       title: '用户管理',
    //       name: 'Applist',
    //       meta: { index: '14', keepAlive: true }
    //     }
    //   ]
    // },
    // {
    //   authId: 'view_menu_merchant_complain',
    //   // rule: [0, 3, 4],
    //   path: '/merchantComplain',
    //   component: Layout,
    //   children: [{
    //     path: 'index',
    //     component: () => import('../pages/merchantComplain/index'),
    //     title: '商户号投诉',
    //     name: 'merchantComplain',
    //     meta: {index: '12', keepAlive: true},
    //   },
    //   ]
    // },
    // {
    //   authId: 'view_menu_ad',
    //   // rule: [0, 3, 4],
    //   path: '/adController',
    //   component: Layout,
    //   children: [{
    //     path: 'index',
    //     component: () => import('../pages/adController/index'),
    //     title: '广告控制',
    //     name: 'adController',
    //     meta: {index: '12', keepAlive: true},
    //   },
    //   ]
    // },
    // {
    //   authId: 'view_menu_ad_new',
    //   // rule: [0, 3, 4],
    //   path: '/loginControl',
    //   component: Layout,
    //   children: [
    //     {
    //       path: 'index',
    //       component: () => import('../pages/loginControl/loginControl'),
    //       title: '登录控制',
    //       name: 'loginControl',
    //       meta: { index: '14', keepAlive: true }
    //     }
    //   ]
    // },
    // {
    //   authId: 'view_menu_ad_new',
    //   // rule: [0, 3, 4],
    //   path: '/adConfig',
    //   component: Layout,
    //   children: [{
    //     path: 'index',
    //     component: () => import('../pages/adController/index-new'),
    //     title: '广告位控制',
    //     name: 'adConfig',
    //     meta: {index: '12', keepAlive: true},
    //   },]
    // },
    // {
    //   path: "/channelVersion",
    //   name: "channelVersion",
    //   component: Layout,
    //   children: [{
    //     path: 'index',
    //     component: () => import("../pages/channelVersionControl/index"),
    //     title: "渠道号控制",
    //     name: "apkChannelControl",
    //     meta: {index: '13', keepAlive: true}
    //   }]
    // },
    // {
    //   authId: 'view_menu_ad_new',
    //   // rule: [0, 3, 4],
    //   path: '/experienceControl',
    //   component: Layout,
    //   children: [{
    //     path: 'index',
    //     component: () => import('../pages/experienceControl/experienceControl'),
    //     title: '体验控制',
    //     name: 'experienceControl',
    //     meta: {index: '15', keepAlive: true},
    //   },
    //   ]
    // },
    // {
    //   authId: 'view_menu_ad_new',
    //   // rule: [0, 3, 4],
    //   path: '/functionControl',
    //   component: Layout,
    //   children: [{
    //     path: 'index',
    //     component: () => import('../pages/functionControl/functionControl'),
    //     title: '功能控制',
    //     name: 'functionControl',
    //     meta: {index: '16', keepAlive: true},
    //   },
    //   ]
    // },
    // {
    //   authId: 'view_menu_activationcode',
    //   // rule: [0, 3, 4],
    //   path: '/activationcode',
    //   component: Layout,
    //   children: [{
    //     path: 'index',
    //     component: ActivationcodeList,
    //     title: '激活码管理',
    //     name: 'activationcode',
    //     meta: {index: '13', keepAlive: true},
    //   }]
    // },
    {
      authId: 'view_menu_private_view',
      path: '/privateView',
      component: Layout,
      children: [
        {
          path: 'index',
          component: PrivateView,
          title: '用户协议/隐私政策',
          name: 'orderList',
          meta: {
            index: '12',
            keepAlive: true
          }
        }
      ]
    },
    // {
    //   path: '/regulatory',
    //   component: Layout,
    //   children: [{
    //     path: 'regulatory',
    //     component: regulatory,
    //     title: '监管投诉',
    //     name: 'regulatory',
    //     meta: {
    //       index: '12',
    //       keepAlive: true
    //     }
    //   }]
    // },
    // {
    //   authId: 'view_menu_report',
    //   path: '/reportData',
    //   component: Layout,
    //   title: '营销数据统计',
    //   children: [{
    //     path: 'reportData',
    //     component: reportData,
    //     title: '实时数据',
    //     name: 'reportData',
    //     meta: {
    //       index: '12',
    //       keepAlive: true
    //     }
    //   }, {
    //     path: "historyData",
    //     component: historyData,
    //     name: "historyData",
    //     title: '历史数据报表',
    //     meta: {
    //       index: '13',
    //       keepAlive: true
    //     }
    //   }, {
    //     path: "configerData",
    //     name: "configerData",
    //     component: configerData,
    //     title: "后台配置",
    //     meta: {
    //       index: '14',
    //       keepAlive: true
    //     }
    //   }]
    // },
    // {
    //   rule: [0, 3, 4],
    //   path: '/order',
    //   component: Layout,
    //   children: [{
    //     path: 'chart',
    //     component: () => import('../pages/statistics/index'),
    //     title: '首页概况',
    //     name: 'chart',
    //     meta: {index: '12', keepAlive: true},
    //   },
    //   ]
    // },
    // {
    //   rule: [0, 3, 4],
    //   path: '/order2',
    //   component: Layout,
    //   children: [{
    //     path: 'chart2',
    //     component: () => import('../pages/tailOrderStatistics/index'),
    //     title: 'PC授权费单统计',
    //     name: 'chart2',
    //     meta: {index: '13', keepAlive: true},
    //   },
    //   ]
    // },
    // {
    //   rule: [0, 3, 4],
    //   path: '/order3',
    //   component: Layout,
    //   children: [{
    //     path: 'chart3',
    //     component: () => import('../pages/orderStatistics/index'),
    //     title: '订单统计',
    //     name: 'chart3',
    //     meta: {index: '13', keepAlive: true},
    //   },
    //   ]
    // },
    // {
    //   rule: [0, 3, 4],
    //   path: '/order5',
    //   component: Layout,
    //   children: [{
    //     path: 'chart5',
    //     component: () => import('../pages/refundOrderStatistics/index'),
    //     title: '退款单统计',
    //     name: 'chart5',
    //     meta: {index: '13', keepAlive: true},
    //   },
    //   ]
    // },
    // {
    //   rule: [0, 3, 4],
    //   path: '/order6',
    //   component: Layout,
    //   children: [{
    //     path: 'chart6',
    //     component: () => import('../pages/routeStatistics/index'),
    //     title: '路径统计',
    //     name: 'chart3',
    //     meta: {index: '13', keepAlive: true},
    //   },
    //   ]
    // },
    {
      authId: 'view_menu_camera_home',
      path: '/home',
      component: Layout,
      children: [
        {
          path: 'list',
          component: () => import('../pages/home/index.vue'),
          title: '首页',
          name: 'Home',
          meta: {
            index: '14',
            keepAlive: true
          }
        }
      ]
    },
    {
      authId: 'view_menu_camera_type',
      path: '/camera-type',
      component: Layout,
      children: [
        {
          path: 'list',
          component: () => import('../pages/cameraType/index.vue'),
          title: '证件照子页',
          name: 'CameraType',
          meta: {
            index: '15',
            keepAlive: true
          }
        }
      ]
    },
    {
      authId: 'view_menu_camera_type_app',
      path: '/camera-type-app',
      component: Layout,
      children: [
        {
          path: 'list',
          component: () => import('../pages/cameraTypeApp/index.vue'),
          title: 'APP证件照',
          name: 'CameraTypeAPP',
          meta: {
            index: '16',
            keepAlive: true
          }
        }
      ]
    },
    {
      authId: 'view_menu_dispute',
      path: '/dispute',
      component: Layout,
      children: [
        {
          path: 'list',
          component: () => import('../pages/dispute/index.vue'),
          title: '争议列表',
          name: 'Dispute',
          meta: {
            index: '17',
            keepAlive: true
          }
        }
      ]
    }
    // {
    //   path: '/print-format',
    //   component: Layout,
    //   children: [
    //     {
    //       path: 'list',
    //       component: () => import('../pages/PrintFormat/index.vue'),
    //       title: '打印版式',
    //       name: 'PrintFormat',
    //       meta: {
    //         index: '15',
    //         keepAlive: true
    //       }
    //     }
    //   ]
    // }
  ]
  //   .filter(function (element) {
  //   //  有authId的需要校验后过滤
  //   let authorized;
  //   if (element.authId) {
  //     authorized = auth.checkViewAuthority(element.authId);
  //   } else {
  //     authorized = true;
  //   }
  //   // console.log(element.authId + ',' + authorized);
  //   return authorized;
  // });
  // 初始化vuex的路由
  // console.log(routes);
  store.commit('setRoutes', routes)
  return store.state.routes
}



// WEBPACK FOOTER //
// ./src/router/index.js